"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M2.5 3.495h17.849v3.246H2.5V3.495zm0 6.49h17.849v3.246H2.5V9.986zm0 9.737H13v-3.246H2.5v3.246zm16.92-4.33l1.08 1.08-2.16 2.16 2.16 2.16-1.08 1.08-2.16-2.16-2.161 2.16-1.08-1.08 2.16-2.16-2.16-2.16 1.08-1.08 2.16 2.16 2.16-2.16z" }), "Delist");
//# sourceMappingURL=StatusDelist.js.map